import ActionDetailButton from "./actionDetailButton.container";

export default ActionDetailButton;
